/* Use the existing Gorgias widget; never submit a message on the visitor's behalf. */
(() => {
  if (customElements.get('ip-contact-chat')) return;

  class IpContactChat extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('click', this.openChat, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async openChat(event) {
      const trigger = event.target.closest('[data-ip-open-chat]');
      if (!trigger) return;

      const status = this.querySelector('[data-ip-chat-status]');
      // The anchor remains a working form link when scripts or chat are unavailable.
      if (!window.GorgiasChat?.open) {
        if (status) status.textContent = status.dataset.unavailable;
        return;
      }

      event.preventDefault();
      if (trigger.getAttribute('aria-busy') === 'true') return;
      trigger.setAttribute('aria-busy', 'true');
      try {
        await window.GorgiasChat.init();
        window.GorgiasChat.open();
        // The legacy theme hides this container for 15 seconds after loading.
        const container = document.getElementById('gorgias-chat-container');
        if (container) container.style.display = '';
        if (status) status.textContent = '';
      } catch {
        if (status) status.textContent = status.dataset.unavailable;
      } finally {
        trigger.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('ip-contact-chat', IpContactChat);
})();
